<template>
    <div>
        <CModal
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Absensi {{ datas.nama }} {{ datas.nik !== '' ? '- '+ datas.nik : ''}}</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px;padding-bottom:20px;">
                    <CTabs :active-tab="activeTab" add-tab-classes="mt-1 mb-2">
                        <CTab @click.native="changeTab(0)">
                            <template slot="title">
                            {{tabs[0]}}
                            </template>
                        </CTab>
                        <CTab @click.native="changeTab(1)">
                            <template slot="title">
                            {{tabs[1]}}
                            </template>
                        </CTab>
                    </CTabs>
                    <CRow v-if="activeTab == 0" class="mb-2">
                        <CCol sm="12">
                            <img class="mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="Absensi export to excel"  width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                    <table v-if="tab == 0">
                        <thead>
                            <tr>
                                <th>Hari, Tanggal</th>
                                <th>Jadwal</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>JKS</th>
                                <th>JKP</th>
                                <th>Status</th>
                                <th>Keterangan</th>
                            </tr>
                        </thead>
                        <tbody v-if="datas.flag == true">
                            <tr v-for="(li, id) in datas.data" :key="id">
                                <td>{{li.hariTanggal}}</td>
                                <td>{{li.jadwal}}</td>
                                <td>{{li.jamMasuk}}</td>
                                <td>{{li.jamKeluar}}</td>
                                <td>{{li.jks}}</td>
                                <td>{{li.jkp}}</td>
                                <td>{{li.status}}</td>
                                <td>{{li.keterangan}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="8">
                                    {{datas.message ? datas.message : 'Data tidak ditemukan'}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <CRow class="mt-2" v-if="tab == 1">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="2" class="h6"><strong>Periode</strong></CCol>
                                <CCol sm="10" class="h6">: {{ datasMangkir.periode }}</CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="2" class="h6"><strong>Tanggal Aktif</strong></CCol>
                                <CCol sm="10" class="h6">: {{ datasMangkir.tanggalAktif }}</CCol>
                            </CRow>
                            <CRow v-if="activeTab == 1" class="mt-1">
                                <CCol sm="6">
                                    <img class="mt-1" v-if="datasMangkir.length != 0" @click="getDownloadMangkir()" style="float:left;cursor:pointer" :src="downloadIcon" title="Mangkir export to excel"  width="20px" height="20px"/>
                                </CCol>
                                <CCol sm="6" class="h6 text-right">
                                    <strong>
                                        <figure class="">
                                            <figcaption class="blockquote-footer">
                                                Last Update <cite>{{ datasMangkir.lastUpdate }}</cite>
                                            </figcaption>
                                        </figure>
                                    </strong>
                                </CCol>
                            </CRow>
                            <table>
                                <thead>
                                    <tr>
                                        <th class="text-center">Hari, Tanggal</th>
                                        <th class="text-center">Keterangan</th>
                                    </tr>
                                </thead>
                                <tbody v-if="datasMangkir.data.length != 0">
                                    <tr v-for="(li, id) in datasMangkir.data" :key="id">
                                        <td class="text-center">{{li.hariTanggal}}</td>
                                        <td class="text-center">{{li.keterangan}}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td class="text-center" colspan="8">
                                            Data tidak ditemukan
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isShown: false,
            closeIcon: require('../assets/menu/icon_close.svg'),
            datas: [],
            datasMangkir: [],
            tabs: [
                'Absensi',
                'Mangkir (1 Tahun)'
            ],
            tab: 0,
            activeTab: 0,
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
        }
    },
    methods: {
        changeTab(val){
            this.tab = val
            this.activeTab = val
        },
        closeModal() {
            this.isShown = false
            this.datas = []
            this.datasMangkir = []
            this.tab = 0
            this.activeTab = 0
        },
        openModal(value) {
            this.getShow = 0
            this.datas = value[0]
            this.datasMangkir = value[1]
            this.isShown = true
        },
        getDownload() {
            this.$emit('download')
        },
        getDownloadMangkir() {
            this.$emit('downloadMangkir')
        }
    },
    watch: {
    }
}
</script>

<style scoped>
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
::v-deep .modal-dialog {
    max-width: 80% !important;
}
::v-deep .nav .nav-tabs {
    display: flex;
}
::v-deep .nav-tabs .nav-item {
    flex-grow: 1;
    position: relative;
    background-color: rgba(244, 244, 244, 1) !important;
    border: 1px solid rgba(224, 224, 224, 1) !important;
    border-radius: 0px;
    width: 3%;
}
::v-deep .nav-tabs .nav-link {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: transparent;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
    padding-right: 32px;
    text-overflow: ellipsis;
    border: none;
}
::v-deep .nav-tabs .nav-link:hover {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
::v-deep .nav-tabs .nav-link.active {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: transparent;
    background-color: white;
}
.nav-tabs li a span {
    color: rgba(96, 96, 96, 1) !important;
    font-size: 12px;
    padding-right: 8px;
    width: 20% !important;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
}
.rows:hover {
    cursor: pointer;
    background-color: whitesmoke;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  /* border-color: ; */
  font-weight: bold;
  color: rgba(21, 100, 153, 1);
  border-bottom: 3px solid rgba(21, 100, 153, 1) !important;
  background-color: transparent;
}
::v-deep .nav-tabs .nav-item {
  border: none !important;
  border-bottom: 1px solid gainsboro;
}

::v-deep .nav-tabs .nav-link {
 padding: 14px;
 background-color: rgba(249, 250, 252, 1);
 border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item a {
  color: rgba(154, 154, 154, 1);
}
::v-deep .nav-item {
  border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item {
  font-weight: bold!important;
  color: #606060;
  background-color: rgba(249, 250, 252, 1);
  width: 25%;
  text-align: center;
}
</style>